import { ConfiguratorUIElementStates, ConfiguratorUIElementWithChildrenState } from '@/stores/CfgUIElementState';
import React, { CSSProperties } from 'react';
import { IUiCfgContainer } from '@canvas-logic/clp-api-types';
import { ProductsContainerCfgUIElement } from '@/UiBuilder/elements/ProductsContainerCfgUIElement/ProductsContainerCfgUIElement';

export class ProductsContainerCfgUIElementState extends ConfiguratorUIElementWithChildrenState {
  constructor(children: Array<ConfiguratorUIElementStates>, viewElement: IUiCfgContainer) {
    super(children, viewElement);
  }

  render(): React.ReactElement {
    let style: CSSProperties = {};

    if (this.viewElement.productsSettings?.layout === 'card') {
      style = {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
      };
    }

    return (
      <ProductsContainerCfgUIElement
        childrenElements={this.children}
        viewElement={this.viewElement}
        key={this.viewElement.id}
      />
    );
  }
}
